export const onboardingMessages = {
    en: {
        language: 'Language',
        menu: {
            website: 'My Website',
            services: 'Services',
            schedule: 'Schedule',
            appointments: 'Appointments',
            profile: 'Profile',
            communication: 'Communication',
        },
        services: {
            title: 'Services',
            empty: 'No services yet.',
            minutes: 'min',
        },
        schedule: {
            title: 'Schedule',
            empty: 'Schedule is not set up yet.',
            dayOff: 'Day off',
            days: {
                monday: 'Monday',
                tuesday: 'Tuesday',
                wednesday: 'Wednesday',
                thursday: 'Thursday',
                friday: 'Friday',
                saturday: 'Saturday',
                sunday: 'Sunday',
            },
        },
        appointments: {
            title: 'Appointments',
            empty: 'No appointments yet.',
            noService: 'Service not specified',
            status: {
                pending: 'Pending',
                confirmed: 'Confirmed',
                cancelled: 'Cancelled',
            },
        },
        profile: {
            title: 'Profile',
            name: 'Name',
            email: 'Email',
            phone: 'Phone',
            createdAt: 'Registered',
            balance: 'Available balance',
        },
        registration: {
            successTitle: 'Check your email',
            successDesc: 'We sent you a confirmation email. Please check your inbox and click the link to verify your account.',
            backToLogin: 'Go to login',
        },
        verification: {
            verifying: 'Verifying your email...',
            successTitle: 'Email verified!',
            successDesc: 'Your account has been successfully verified. You can now log in.',
            alreadyVerifiedTitle: 'Already verified',
            alreadyVerifiedDesc: 'Your account has already been verified. Please log in.',
            errorTitle: 'Verification failed',
            errorDesc: 'The verification link is invalid or has expired.',
            brokenLink: 'The verification link is broken. Please request a new one.',
            resendLink: 'Resend verification link',
            linkResent: 'A new verification link has been sent to your email.',
            goToLogin: 'Go to login',
        },
        onboarding: {
            step: 'Step',
            next: 'Continue',
            skip: 'Skip this step',
            back: 'Back',
            professionTitle: 'What do you do?',
            professionDesc: 'Tell us about your profession so we can help you set up faster.',
            otherProfession: 'Other',
            step1Title: 'Create your website',
            step2Title: 'Upload your avatar',
            step3Title: 'Your name or title',
            step4Title: 'Set up your services',
            step5Title: 'Set up your schedule',
            step55Title: 'Add photos of your work',
            step6Title: 'Phone number',
            step7Title: 'Email address',
            step8Title: 'Social networks',
            step9Title: 'Impressum',
            step1Desc: 'Choose a unique name for your booking page.',
            step2Desc: 'Upload a profile photo so clients can recognize you.',
            step3Desc: 'Enter your name or business name that clients will see.',
            step4Desc: 'Add the services you offer. Select your profession to get suggestions or add manually.',
            step5Desc: 'Set your working hours so clients know when to book.',
            step55Desc: 'Show potential clients photos of your work or completed projects.',
            step6Desc: 'Add a phone number so clients can reach you.',
            step7Desc: 'Add an email for client communications.',
            step8Desc: 'Link your social media profiles.',
            step9Desc: 'Legal information about you or your business.',
            websiteName: 'Website name',
            websiteNamePlaceholder: 'mysite',
            domainMinLength: 'Must be at least 4 characters',
            domainAlphaNum: 'Only letters and numbers allowed',
            domainTaken: 'This name is already taken',
            domainCheckError: 'Could not verify availability',
            domainAvailable: 'This name is available!',
            checking: 'Checking',
            chooseFile: 'Choose file',
            yourName: 'Name or title',
            yourNamePlaceholder: 'e.g. Jane Smith or Beauty Studio',
            selectProfession: 'Select your profession',
            chooseProfession: '— Choose a profession —',
            serviceName: 'Service name',
            serviceDesc: 'Description',
            min: 'min',
            addService: 'Add service manually',
            presets: 'Quick presets',
            workDays: 'Working days',
            bookNow: 'Book now',
            addPhotos: 'Add photos',
            phoneNumber: 'Phone number',
            impressumQuestion: 'Would you like to add an Impressum?',
            impressumRecommended: 'An Impressum is recommended and in some countries legally required for commercial websites.',
            impressumEdit: 'Edit your Impressum',
            impressumHint: 'Replace the placeholder values with your actual information.',
            yes: 'Yes',
            no: 'No, skip',
            cookieText: 'This website uses cookies to ensure you get the best experience.',
            cookieAccept: 'Accept',
            hasImage: 'Image uploaded',
            empty: 'Not set',
            photos: 'photos',
            links: 'links',
            edit: 'Edit',
            hide: 'Hide',
            show: 'Show',
            save: 'Save',
            cancel: 'Cancel',
            galleryEditHint: 'Gallery editing is available in the full editor.',
            elementManaged: 'This element is managed automatically.',
            appName: 'Timebrella',
            tagline: 'Protect against chaos',
        },
        footer: {
            impressum: 'Imprint',
            tos: 'Terms of Service',
        },
    },
    de: {
        language: 'Sprache',
        menu: {
            website: 'Meine Website',
            services: 'Dienstleistungen',
            schedule: 'Zeitplan',
            appointments: 'Termine',
            profile: 'Profil',
            communication: 'Kommunikation',
        },
        services: {
            title: 'Dienstleistungen',
            empty: 'Noch keine Dienstleistungen.',
            minutes: 'Min',
        },
        schedule: {
            title: 'Zeitplan',
            empty: 'Zeitplan ist noch nicht eingerichtet.',
            dayOff: 'Frei',
            days: {
                monday: 'Montag',
                tuesday: 'Dienstag',
                wednesday: 'Mittwoch',
                thursday: 'Donnerstag',
                friday: 'Freitag',
                saturday: 'Samstag',
                sunday: 'Sonntag',
            },
        },
        appointments: {
            title: 'Termine',
            empty: 'Noch keine Termine.',
            noService: 'Dienst nicht angegeben',
            status: {
                pending: 'Ausstehend',
                confirmed: 'Bestätigt',
                cancelled: 'Storniert',
            },
        },
        profile: {
            title: 'Profil',
            name: 'Name',
            email: 'E-Mail',
            phone: 'Telefon',
            createdAt: 'Registriert',
            balance: 'Verfügbares Guthaben',
        },
        registration: {
            successTitle: 'Prüfen Sie Ihre E-Mail',
            successDesc: 'Wir haben Ihnen eine Bestätigungs-E-Mail gesendet. Bitte prüfen Sie Ihren Posteingang und klicken Sie auf den Link, um Ihr Konto zu bestätigen.',
            backToLogin: 'Zum Login',
        },
        verification: {
            verifying: 'E-Mail wird überprüft...',
            successTitle: 'E-Mail bestätigt!',
            successDesc: 'Ihr Konto wurde erfolgreich bestätigt. Sie können sich jetzt anmelden.',
            alreadyVerifiedTitle: 'Bereits bestätigt',
            alreadyVerifiedDesc: 'Ihr Konto wurde bereits bestätigt. Bitte melden Sie sich an.',
            errorTitle: 'Bestätigung fehlgeschlagen',
            errorDesc: 'Der Bestätigungslink ist ungültig oder abgelaufen.',
            brokenLink: 'Der Bestätigungslink ist fehlerhaft. Bitte fordern Sie einen neuen an.',
            resendLink: 'Bestätigungslink erneut senden',
            linkResent: 'Ein neuer Bestätigungslink wurde an Ihre E-Mail gesendet.',
            goToLogin: 'Zum Login',
        },
        onboarding: {
            step: 'Schritt',
            next: 'Weiter',
            skip: 'Diesen Schritt überspringen',
            back: 'Zurück',
            professionTitle: 'Was machen Sie?',
            professionDesc: 'Erzählen Sie uns von Ihrem Beruf, damit wir Ihnen schneller helfen können.',
            otherProfession: 'Andere',
            step1Title: 'Website erstellen',
            step2Title: 'Avatar hochladen',
            step3Title: 'Ihr Name oder Titel',
            step4Title: 'Dienstleistungen einrichten',
            step5Title: 'Zeitplan einrichten',
            step55Title: 'Fotos Ihrer Arbeit hinzufügen',
            step6Title: 'Telefonnummer',
            step7Title: 'E-Mail-Adresse',
            step8Title: 'Soziale Netzwerke',
            step9Title: 'Impressum',
            step1Desc: 'Wählen Sie einen einzigartigen Namen für Ihre Buchungsseite.',
            step2Desc: 'Laden Sie ein Profilfoto hoch, damit Kunden Sie erkennen.',
            step3Desc: 'Geben Sie Ihren Namen oder Firmennamen ein.',
            step4Desc: 'Fügen Sie die Dienstleistungen hinzu, die Sie anbieten.',
            step5Desc: 'Legen Sie Ihre Arbeitszeiten fest.',
            step55Desc: 'Zeigen Sie potenziellen Kunden Fotos Ihrer Arbeit.',
            step6Desc: 'Telefonnummer für Kundenkontakt hinzufügen.',
            step7Desc: 'E-Mail für Kundenkommunikation hinzufügen.',
            step8Desc: 'Verknüpfen Sie Ihre Social-Media-Profile.',
            step9Desc: 'Rechtliche Informationen über Sie oder Ihr Unternehmen.',
            websiteName: 'Website-Name',
            websiteNamePlaceholder: 'meineseite',
            domainMinLength: 'Mindestens 4 Zeichen',
            domainAlphaNum: 'Nur Buchstaben und Zahlen erlaubt',
            domainTaken: 'Dieser Name ist bereits vergeben',
            domainCheckError: 'Verfügbarkeit konnte nicht überprüft werden',
            domainAvailable: 'Dieser Name ist verfügbar!',
            checking: 'Prüfe',
            chooseFile: 'Datei wählen',
            yourName: 'Name oder Titel',
            yourNamePlaceholder: 'z.B. Max Mustermann oder Beauty Studio',
            selectProfession: 'Beruf auswählen',
            chooseProfession: '— Beruf wählen —',
            serviceName: 'Dienstleistungsname',
            serviceDesc: 'Beschreibung',
            min: 'Min',
            addService: 'Dienst manuell hinzufügen',
            presets: 'Schnellvorlagen',
            workDays: 'Arbeitstage',
            bookNow: 'Jetzt buchen',
            addPhotos: 'Fotos hinzufügen',
            phoneNumber: 'Telefonnummer',
            impressumQuestion: 'Möchten Sie ein Impressum hinzufügen?',
            impressumRecommended: 'Ein Impressum ist empfohlen und in einigen Ländern gesetzlich vorgeschrieben.',
            impressumEdit: 'Impressum bearbeiten',
            impressumHint: 'Ersetzen Sie die Platzhalter durch Ihre tatsächlichen Daten.',
            yes: 'Ja',
            no: 'Nein, überspringen',
            cookieText: 'Diese Website verwendet Cookies, um Ihnen das beste Erlebnis zu bieten.',
            cookieAccept: 'Akzeptieren',
            hasImage: 'Bild hochgeladen',
            empty: 'Nicht festgelegt',
            photos: 'Fotos',
            links: 'Links',
            edit: 'Bearbeiten',
            hide: 'Ausblenden',
            show: 'Anzeigen',
            save: 'Speichern',
            cancel: 'Abbrechen',
            galleryEditHint: 'Galerie-Bearbeitung ist im vollständigen Editor verfügbar.',
            elementManaged: 'Dieses Element wird automatisch verwaltet.',
            appName: 'Timebrella',
            tagline: 'Schutz vor dem Chaos',
        },
        footer: {
            impressum: 'Impressum',
            tos: 'AGBs',
        },
    },
    ru: {
        language: 'Язык',
        menu: {
            website: 'Мой сайт',
            services: 'Услуги',
            schedule: 'Расписание',
            appointments: 'Записи',
            profile: 'Профиль',
            communication: 'Коммуникация',
        },
        services: {
            title: 'Услуги',
            empty: 'Услуг пока нет.',
            minutes: 'мин',
        },
        schedule: {
            title: 'Расписание',
            empty: 'Расписание ещё не настроено.',
            dayOff: 'Выходной',
            days: {
                monday: 'Понедельник',
                tuesday: 'Вторник',
                wednesday: 'Среда',
                thursday: 'Четверг',
                friday: 'Пятница',
                saturday: 'Суббота',
                sunday: 'Воскресенье',
            },
        },
        appointments: {
            title: 'Записи',
            empty: 'Записей пока нет.',
            noService: 'Услуга не указана',
            status: {
                pending: 'Ожидает',
                confirmed: 'Подтверждена',
                cancelled: 'Отменена',
            },
        },
        profile: {
            title: 'Профиль',
            name: 'Имя',
            email: 'Email',
            phone: 'Телефон',
            createdAt: 'Зарегистрирован',
            balance: 'Доступный баланс',
        },
        registration: {
            successTitle: 'Проверьте почту',
            successDesc: 'Мы отправили вам письмо с подтверждением. Проверьте входящие и перейдите по ссылке для активации аккаунта.',
            backToLogin: 'Перейти к входу',
        },
        verification: {
            verifying: 'Подтверждаем email...',
            successTitle: 'Email подтверждён!',
            successDesc: 'Ваш аккаунт успешно подтверждён. Теперь вы можете войти.',
            alreadyVerifiedTitle: 'Уже подтверждён',
            alreadyVerifiedDesc: 'Ваш аккаунт уже подтверждён. Пожалуйста, войдите.',
            errorTitle: 'Ошибка подтверждения',
            errorDesc: 'Ссылка недействительна или срок её действия истёк.',
            brokenLink: 'Ссылка повреждена. Запросите новую.',
            resendLink: 'Отправить ссылку повторно',
            linkResent: 'Новая ссылка отправлена на вашу почту.',
            goToLogin: 'Перейти к входу',
        },
        onboarding: {
            step: 'Шаг',
            next: 'Продолжить',
            skip: 'Пропустить этот шаг',
            back: 'Назад',
            professionTitle: 'Чем вы занимаетесь?',
            professionDesc: 'Расскажите о вашей профессии, чтобы мы помогли настроить быстрее.',
            otherProfession: 'Другое',
            step1Title: 'Создайте сайт',
            step2Title: 'Загрузите аватар',
            step3Title: 'Ваше имя или название',
            step4Title: 'Настройте услуги',
            step5Title: 'Настройте расписание',
            step55Title: 'Добавьте фото работ',
            step6Title: 'Номер телефона',
            step7Title: 'Email адрес',
            step8Title: 'Социальные сети',
            step9Title: 'Impressum',
            step1Desc: 'Выберите уникальное имя для вашей страницы бронирования.',
            step2Desc: 'Загрузите фото профиля, чтобы клиенты вас узнали.',
            step3Desc: 'Введите ваше имя или название, которое увидят клиенты.',
            step4Desc: 'Добавьте услуги, которые вы предлагаете. Выберите профессию для подсказок или добавьте вручную.',
            step5Desc: 'Установите рабочие часы для записи клиентов.',
            step55Desc: 'Покажите потенциальным клиентам фото ваших работ или выполненных проектов.',
            step6Desc: 'Добавьте номер телефона для связи с клиентами.',
            step7Desc: 'Добавьте email для общения с клиентами.',
            step8Desc: 'Привяжите ваши профили в социальных сетях.',
            step9Desc: 'Юридическая информация о вас или вашем бизнесе.',
            websiteName: 'Название сайта',
            websiteNamePlaceholder: 'mojsajt',
            domainMinLength: 'Минимум 4 символа',
            domainAlphaNum: 'Только буквы и цифры',
            domainTaken: 'Это имя уже занято',
            domainCheckError: 'Не удалось проверить доступность',
            domainAvailable: 'Это имя доступно!',
            checking: 'Проверяем',
            chooseFile: 'Выбрать файл',
            yourName: 'Имя или название',
            yourNamePlaceholder: 'напр. Иван Иванов или Студия красоты',
            selectProfession: 'Выберите профессию',
            chooseProfession: '— Выберите профессию —',
            serviceName: 'Название услуги',
            serviceDesc: 'Описание',
            min: 'мин',
            addService: 'Добавить услугу вручную',
            presets: 'Быстрые шаблоны',
            workDays: 'Рабочие дни',
            bookNow: 'Записаться',
            addPhotos: 'Добавить фото',
            phoneNumber: 'Номер телефона',
            impressumQuestion: 'Хотите добавить Impressum?',
            impressumRecommended: 'Impressum рекомендуется и в некоторых странах обязателен для коммерческих сайтов.',
            impressumEdit: 'Редактировать Impressum',
            impressumHint: 'Замените шаблонные значения на вашу реальную информацию.',
            yes: 'Да',
            no: 'Нет, пропустить',
            cookieText: 'Этот сайт использует cookies для лучшего взаимодействия.',
            cookieAccept: 'Принять',
            hasImage: 'Изображение загружено',
            empty: 'Не задано',
            photos: 'фото',
            links: 'ссылок',
            edit: 'Редактировать',
            hide: 'Скрыть',
            show: 'Показать',
            save: 'Сохранить',
            cancel: 'Отмена',
            galleryEditHint: 'Редактирование галереи доступно в полном редакторе.',
            elementManaged: 'Этот элемент управляется автоматически.',
            appName: 'Timebrella',
            tagline: 'Защита от хаоса',
        },
        footer: {
            impressum: 'Импрессум',
            tos: 'Условия использования',
        },
    },
    es: {
        language: 'Idioma',
        menu: {
            website: 'Mi sitio web',
            services: 'Servicios',
            schedule: 'Horario',
            appointments: 'Citas',
            profile: 'Perfil',
            communication: 'Comunicación',
        },
        services: {
            title: 'Servicios',
            empty: 'Aún no hay servicios.',
            minutes: 'min',
        },
        schedule: {
            title: 'Horario',
            empty: 'El horario aún no está configurado.',
            dayOff: 'Libre',
            days: {
                monday: 'Lunes',
                tuesday: 'Martes',
                wednesday: 'Miércoles',
                thursday: 'Jueves',
                friday: 'Viernes',
                saturday: 'Sábado',
                sunday: 'Domingo',
            },
        },
        appointments: {
            title: 'Citas',
            empty: 'Aún no hay citas.',
            noService: 'Servicio no especificado',
            status: {
                pending: 'Pendiente',
                confirmed: 'Confirmada',
                cancelled: 'Cancelada',
            },
        },
        profile: {
            title: 'Perfil',
            name: 'Nombre',
            email: 'Correo',
            phone: 'Teléfono',
            createdAt: 'Registrado',
            balance: 'Saldo disponible',
        },
        registration: {
            successTitle: 'Revisa tu correo',
            successDesc: 'Te hemos enviado un correo de confirmación. Revisa tu bandeja de entrada y haz clic en el enlace para verificar tu cuenta.',
            backToLogin: 'Ir al inicio de sesión',
        },
        verification: {
            verifying: 'Verificando tu email...',
            successTitle: 'Email verificado!',
            successDesc: 'Tu cuenta ha sido verificada correctamente. Ya puedes iniciar sesión.',
            alreadyVerifiedTitle: 'Ya verificado',
            alreadyVerifiedDesc: 'Tu cuenta ya ha sido verificada. Por favor, inicia sesión.',
            errorTitle: 'Error de verificación',
            errorDesc: 'El enlace de verificación no es válido o ha expirado.',
            brokenLink: 'El enlace de verificación está roto. Solicita uno nuevo.',
            resendLink: 'Reenviar enlace de verificación',
            linkResent: 'Se ha enviado un nuevo enlace de verificación a tu correo.',
            goToLogin: 'Ir al inicio de sesión',
        },
        onboarding: {
            step: 'Paso',
            next: 'Continuar',
            skip: 'Omitir este paso',
            back: 'Atrás',
            professionTitle: 'A que te dedicas?',
            professionDesc: 'Cuéntanos sobre tu profesión para ayudarte a configurar más rápido.',
            otherProfession: 'Otro',
            step1Title: 'Crear sitio web',
            step2Title: 'Subir avatar',
            step3Title: 'Tu nombre o título',
            step4Title: 'Configurar servicios',
            step5Title: 'Configurar horario',
            step55Title: 'Añadir fotos de tu trabajo',
            step6Title: 'Número de teléfono',
            step7Title: 'Dirección de email',
            step8Title: 'Redes sociales',
            step9Title: 'Aviso legal',
            step1Desc: 'Elige un nombre único para tu página de reservas.',
            step2Desc: 'Sube una foto de perfil para que los clientes te reconozcan.',
            step3Desc: 'Introduce tu nombre o el de tu negocio.',
            step4Desc: 'Añade los servicios que ofreces.',
            step5Desc: 'Establece tu horario de trabajo.',
            step55Desc: 'Muestra a los clientes potenciales fotos de tu trabajo.',
            step6Desc: 'Añade un número de teléfono de contacto.',
            step7Desc: 'Añade un email para la comunicación con clientes.',
            step8Desc: 'Vincula tus perfiles en redes sociales.',
            step9Desc: 'Información legal sobre ti o tu negocio.',
            websiteName: 'Nombre del sitio',
            websiteNamePlaceholder: 'misitio',
            domainMinLength: 'Mínimo 4 caracteres',
            domainAlphaNum: 'Solo letras y números',
            domainTaken: 'Este nombre ya está en uso',
            domainCheckError: 'No se pudo verificar la disponibilidad',
            domainAvailable: '¡Este nombre está disponible!',
            checking: 'Verificando',
            chooseFile: 'Elegir archivo',
            yourName: 'Nombre o título',
            yourNamePlaceholder: 'ej. María García o Estudio de Belleza',
            selectProfession: 'Selecciona tu profesión',
            chooseProfession: '— Elige una profesión —',
            serviceName: 'Nombre del servicio',
            serviceDesc: 'Descripción',
            min: 'min',
            addService: 'Añadir servicio manualmente',
            presets: 'Plantillas rápidas',
            workDays: 'Días laborables',
            bookNow: 'Reservar ahora',
            addPhotos: 'Añadir fotos',
            phoneNumber: 'Número de teléfono',
            impressumQuestion: '¿Deseas añadir un aviso legal?',
            impressumRecommended: 'Un aviso legal es recomendado y en algunos países obligatorio.',
            impressumEdit: 'Editar aviso legal',
            impressumHint: 'Reemplaza los valores de ejemplo con tu información real.',
            yes: 'Sí',
            no: 'No, omitir',
            cookieText: 'Este sitio web utiliza cookies para garantizar la mejor experiencia.',
            cookieAccept: 'Aceptar',
            hasImage: 'Imagen subida',
            empty: 'No establecido',
            photos: 'fotos',
            links: 'enlaces',
            edit: 'Editar',
            hide: 'Ocultar',
            show: 'Mostrar',
            save: 'Guardar',
            cancel: 'Cancelar',
            galleryEditHint: 'La edición de la galería está disponible en el editor completo.',
            elementManaged: 'Este elemento se gestiona automáticamente.',
            appName: 'Timebrella',
            tagline: 'Protección contra el caos',
        },
        footer: {
            impressum: 'Aviso legal',
            tos: 'Términos de servicio',
        },
    },
    fr: {
        language: 'Langue',
        menu: {
            website: 'Mon site',
            services: 'Services',
            schedule: 'Planning',
            appointments: 'Rendez-vous',
            profile: 'Profil',
            communication: 'Communication',
        },
        services: {
            title: 'Services',
            empty: 'Aucun service pour le moment.',
            minutes: 'min',
        },
        schedule: {
            title: 'Planning',
            empty: 'Le planning n\'est pas encore configuré.',
            dayOff: 'Repos',
            days: {
                monday: 'Lundi',
                tuesday: 'Mardi',
                wednesday: 'Mercredi',
                thursday: 'Jeudi',
                friday: 'Vendredi',
                saturday: 'Samedi',
                sunday: 'Dimanche',
            },
        },
        appointments: {
            title: 'Rendez-vous',
            empty: 'Aucun rendez-vous pour le moment.',
            noService: 'Service non spécifié',
            status: {
                pending: 'En attente',
                confirmed: 'Confirmé',
                cancelled: 'Annulé',
            },
        },
        profile: {
            title: 'Profil',
            name: 'Nom',
            email: 'Email',
            phone: 'Téléphone',
            createdAt: 'Inscrit',
            balance: 'Solde disponible',
        },
        registration: {
            successTitle: 'Vérifiez votre email',
            successDesc: 'Nous vous avons envoyé un email de confirmation. Veuillez vérifier votre boîte de réception et cliquer sur le lien pour activer votre compte.',
            backToLogin: 'Aller à la connexion',
        },
        verification: {
            verifying: 'Vérification de votre email...',
            successTitle: 'Email vérifié !',
            successDesc: 'Votre compte a été vérifié avec succès. Vous pouvez maintenant vous connecter.',
            alreadyVerifiedTitle: 'Déjà vérifié',
            alreadyVerifiedDesc: 'Votre compte a déjà été vérifié. Veuillez vous connecter.',
            errorTitle: 'Échec de la vérification',
            errorDesc: 'Le lien de vérification est invalide ou a expiré.',
            brokenLink: 'Le lien de vérification est cassé. Veuillez en demander un nouveau.',
            resendLink: 'Renvoyer le lien de vérification',
            linkResent: 'Un nouveau lien de vérification a été envoyé à votre email.',
            goToLogin: 'Aller à la connexion',
        },
        onboarding: {
            step: 'Étape',
            next: 'Continuer',
            skip: 'Passer cette étape',
            back: 'Retour',
            professionTitle: 'Que faites-vous ?',
            professionDesc: 'Parlez-nous de votre profession pour vous aider à configurer plus vite.',
            otherProfession: 'Autre',
            step1Title: 'Créer votre site',
            step2Title: 'Télécharger votre avatar',
            step3Title: 'Votre nom ou titre',
            step4Title: 'Configurer vos services',
            step5Title: 'Configurer votre planning',
            step55Title: 'Ajouter des photos de vos réalisations',
            step6Title: 'Numéro de téléphone',
            step7Title: 'Adresse email',
            step8Title: 'Réseaux sociaux',
            step9Title: 'Mentions légales',
            step1Desc: 'Choisissez un nom unique pour votre page de réservation.',
            step2Desc: 'Téléchargez une photo de profil.',
            step3Desc: 'Entrez votre nom ou le nom de votre entreprise.',
            step4Desc: 'Ajoutez les services que vous proposez.',
            step5Desc: 'Définissez vos horaires de travail.',
            step55Desc: 'Montrez aux clients potentiels des photos de votre travail.',
            step6Desc: 'Ajoutez un numéro de téléphone.',
            step7Desc: 'Ajoutez un email pour la communication.',
            step8Desc: 'Liez vos profils de réseaux sociaux.',
            step9Desc: 'Informations légales sur vous ou votre entreprise.',
            websiteName: 'Nom du site',
            websiteNamePlaceholder: 'monsite',
            domainMinLength: 'Minimum 4 caractères',
            domainAlphaNum: 'Lettres et chiffres uniquement',
            domainTaken: 'Ce nom est déjà pris',
            domainCheckError: 'Impossible de vérifier la disponibilité',
            domainAvailable: 'Ce nom est disponible !',
            checking: 'Vérification',
            chooseFile: 'Choisir un fichier',
            yourName: 'Nom ou titre',
            yourNamePlaceholder: 'ex. Marie Dupont ou Studio Beauté',
            selectProfession: 'Sélectionnez votre profession',
            chooseProfession: '— Choisissez une profession —',
            serviceName: 'Nom du service',
            serviceDesc: 'Description',
            min: 'min',
            addService: 'Ajouter un service manuellement',
            presets: 'Modèles rapides',
            workDays: 'Jours de travail',
            bookNow: 'Réserver',
            addPhotos: 'Ajouter des photos',
            phoneNumber: 'Numéro de téléphone',
            impressumQuestion: 'Souhaitez-vous ajouter des mentions légales ?',
            impressumRecommended: 'Les mentions légales sont recommandées et dans certains pays obligatoires.',
            impressumEdit: 'Modifier les mentions légales',
            impressumHint: 'Remplacez les valeurs par vos informations réelles.',
            yes: 'Oui',
            no: 'Non, passer',
            cookieText: 'Ce site utilise des cookies pour vous garantir la meilleure expérience.',
            cookieAccept: 'Accepter',
            hasImage: 'Image téléchargée',
            empty: 'Non défini',
            photos: 'photos',
            links: 'liens',
            edit: 'Modifier',
            hide: 'Masquer',
            show: 'Afficher',
            save: 'Enregistrer',
            cancel: 'Annuler',
            galleryEditHint: 'La modification de la galerie est disponible dans l\'éditeur complet.',
            elementManaged: 'Cet élément est géré automatiquement.',
            appName: 'Timebrella',
            tagline: 'Protégez-vous du chaos',
        },
        footer: {
            impressum: 'Mentions légales',
            tos: 'CGU',
        },
    },
    it: {
        language: 'Lingua',
        menu: {
            website: 'Il mio sito',
            services: 'Servizi',
            schedule: 'Orario',
            appointments: 'Appuntamenti',
            profile: 'Profilo',
            communication: 'Comunicazione',
        },
        services: {
            title: 'Servizi',
            empty: 'Nessun servizio ancora.',
            minutes: 'min',
        },
        schedule: {
            title: 'Orario',
            empty: 'L\'orario non è ancora configurato.',
            dayOff: 'Giorno libero',
            days: {
                monday: 'Lunedì',
                tuesday: 'Martedì',
                wednesday: 'Mercoledì',
                thursday: 'Giovedì',
                friday: 'Venerdì',
                saturday: 'Sabato',
                sunday: 'Domenica',
            },
        },
        appointments: {
            title: 'Appuntamenti',
            empty: 'Nessun appuntamento ancora.',
            noService: 'Servizio non specificato',
            status: {
                pending: 'In attesa',
                confirmed: 'Confermato',
                cancelled: 'Annullato',
            },
        },
        profile: {
            title: 'Profilo',
            name: 'Nome',
            email: 'Email',
            phone: 'Telefono',
            createdAt: 'Registrato',
            balance: 'Saldo disponibile',
        },
        registration: {
            successTitle: 'Controlla la tua email',
            successDesc: 'Ti abbiamo inviato un\'email di conferma. Controlla la tua casella di posta e clicca sul link per verificare il tuo account.',
            backToLogin: 'Vai al login',
        },
        verification: {
            verifying: 'Verifica dell\'email in corso...',
            successTitle: 'Email verificata!',
            successDesc: 'Il tuo account è stato verificato con successo. Ora puoi accedere.',
            alreadyVerifiedTitle: 'Già verificato',
            alreadyVerifiedDesc: 'Il tuo account è già stato verificato. Effettua il login.',
            errorTitle: 'Verifica fallita',
            errorDesc: 'Il link di verifica non è valido o è scaduto.',
            brokenLink: 'Il link di verifica è danneggiato. Richiedine uno nuovo.',
            resendLink: 'Reinvia il link di verifica',
            linkResent: 'Un nuovo link di verifica è stato inviato alla tua email.',
            goToLogin: 'Vai al login',
        },
        onboarding: {
            step: 'Passo',
            next: 'Continua',
            skip: 'Salta questo passo',
            back: 'Indietro',
            professionTitle: 'Cosa fai?',
            professionDesc: 'Dicci la tua professione per aiutarti a configurare più velocemente.',
            otherProfession: 'Altro',
            step1Title: 'Crea il tuo sito',
            step2Title: 'Carica il tuo avatar',
            step3Title: 'Il tuo nome o titolo',
            step4Title: 'Configura i servizi',
            step5Title: 'Configura l\'orario',
            step55Title: 'Aggiungi foto dei tuoi lavori',
            step6Title: 'Numero di telefono',
            step7Title: 'Indirizzo email',
            step8Title: 'Social network',
            step9Title: 'Note legali',
            step1Desc: 'Scegli un nome unico per la tua pagina di prenotazione.',
            step2Desc: 'Carica una foto profilo.',
            step3Desc: 'Inserisci il tuo nome o il nome della tua attività.',
            step4Desc: 'Aggiungi i servizi che offri.',
            step5Desc: 'Imposta i tuoi orari di lavoro.',
            step55Desc: 'Mostra ai potenziali clienti foto dei tuoi lavori.',
            step6Desc: 'Aggiungi un numero di telefono.',
            step7Desc: 'Aggiungi un\'email per la comunicazione.',
            step8Desc: 'Collega i tuoi profili social.',
            step9Desc: 'Informazioni legali su di te o la tua attività.',
            websiteName: 'Nome del sito',
            websiteNamePlaceholder: 'miosito',
            domainMinLength: 'Minimo 4 caratteri',
            domainAlphaNum: 'Solo lettere e numeri',
            domainTaken: 'Questo nome è già in uso',
            domainCheckError: 'Impossibile verificare la disponibilità',
            domainAvailable: 'Questo nome è disponibile!',
            checking: 'Verifico',
            chooseFile: 'Scegli file',
            yourName: 'Nome o titolo',
            yourNamePlaceholder: 'es. Marco Rossi o Studio Bellezza',
            selectProfession: 'Seleziona la tua professione',
            chooseProfession: '— Scegli una professione —',
            serviceName: 'Nome del servizio',
            serviceDesc: 'Descrizione',
            min: 'min',
            addService: 'Aggiungi servizio manualmente',
            presets: 'Modelli rapidi',
            workDays: 'Giorni lavorativi',
            bookNow: 'Prenota ora',
            addPhotos: 'Aggiungi foto',
            phoneNumber: 'Numero di telefono',
            impressumQuestion: 'Vuoi aggiungere le note legali?',
            impressumRecommended: 'Le note legali sono raccomandate e in alcuni paesi obbligatorie.',
            impressumEdit: 'Modifica note legali',
            impressumHint: 'Sostituisci i valori segnaposto con le tue informazioni reali.',
            yes: 'Sì',
            no: 'No, salta',
            cookieText: 'Questo sito utilizza i cookie per garantire la migliore esperienza.',
            cookieAccept: 'Accetta',
            hasImage: 'Immagine caricata',
            empty: 'Non impostato',
            photos: 'foto',
            links: 'link',
            edit: 'Modifica',
            hide: 'Nascondi',
            show: 'Mostra',
            save: 'Salva',
            cancel: 'Annulla',
            galleryEditHint: 'La modifica della galleria è disponibile nell\'editor completo.',
            elementManaged: 'Questo elemento è gestito automaticamente.',
            appName: 'Timebrella',
            tagline: 'Protezione dal caos',
        },
        footer: {
            impressum: 'Note legali',
            tos: 'Termini di servizio',
        },
    },
    pt: {
        language: 'Idioma',
        menu: {
            website: 'Meu site',
            services: 'Serviços',
            schedule: 'Horário',
            appointments: 'Agendamentos',
            profile: 'Perfil',
            communication: 'Comunicação',
        },
        services: {
            title: 'Serviços',
            empty: 'Nenhum serviço ainda.',
            minutes: 'min',
        },
        schedule: {
            title: 'Horário',
            empty: 'O horário ainda não foi configurado.',
            dayOff: 'Folga',
            days: {
                monday: 'Segunda-feira',
                tuesday: 'Terça-feira',
                wednesday: 'Quarta-feira',
                thursday: 'Quinta-feira',
                friday: 'Sexta-feira',
                saturday: 'Sábado',
                sunday: 'Domingo',
            },
        },
        appointments: {
            title: 'Agendamentos',
            empty: 'Nenhum agendamento ainda.',
            noService: 'Serviço não especificado',
            status: {
                pending: 'Pendente',
                confirmed: 'Confirmado',
                cancelled: 'Cancelado',
            },
        },
        profile: {
            title: 'Perfil',
            name: 'Nome',
            email: 'Email',
            phone: 'Telefone',
            createdAt: 'Registrado',
            balance: 'Saldo disponível',
        },
        registration: {
            successTitle: 'Verifique seu email',
            successDesc: 'Enviamos um email de confirmação. Verifique sua caixa de entrada e clique no link para ativar sua conta.',
            backToLogin: 'Ir para o login',
        },
        verification: {
            verifying: 'Verificando seu email...',
            successTitle: 'Email verificado!',
            successDesc: 'Sua conta foi verificada com sucesso. Agora você pode fazer login.',
            alreadyVerifiedTitle: 'Já verificado',
            alreadyVerifiedDesc: 'Sua conta já foi verificada. Por favor, faça login.',
            errorTitle: 'Falha na verificação',
            errorDesc: 'O link de verificação é inválido ou expirou.',
            brokenLink: 'O link de verificação está quebrado. Solicite um novo.',
            resendLink: 'Reenviar link de verificação',
            linkResent: 'Um novo link de verificação foi enviado para seu email.',
            goToLogin: 'Ir para o login',
        },
        onboarding: {
            step: 'Passo',
            next: 'Continuar',
            skip: 'Pular este passo',
            back: 'Voltar',
            professionTitle: 'O que você faz?',
            professionDesc: 'Conte-nos sobre sua profissão para ajudá-lo a configurar mais rápido.',
            otherProfession: 'Outro',
            step1Title: 'Criar seu site',
            step2Title: 'Enviar seu avatar',
            step3Title: 'Seu nome ou título',
            step4Title: 'Configurar serviços',
            step5Title: 'Configurar horários',
            step55Title: 'Adicionar fotos do seu trabalho',
            step6Title: 'Número de telefone',
            step7Title: 'Endereço de email',
            step8Title: 'Redes sociais',
            step9Title: 'Informações legais',
            step1Desc: 'Escolha um nome único para sua página de agendamento.',
            step2Desc: 'Envie uma foto de perfil.',
            step3Desc: 'Digite seu nome ou o nome do seu negócio.',
            step4Desc: 'Adicione os serviços que você oferece.',
            step5Desc: 'Defina seus horários de trabalho.',
            step55Desc: 'Mostre aos clientes potenciais fotos do seu trabalho.',
            step6Desc: 'Adicione um número de telefone.',
            step7Desc: 'Adicione um email para comunicação.',
            step8Desc: 'Vincule seus perfis de redes sociais.',
            step9Desc: 'Informações legais sobre você ou seu negócio.',
            websiteName: 'Nome do site',
            websiteNamePlaceholder: 'meusite',
            domainMinLength: 'Mínimo 4 caracteres',
            domainAlphaNum: 'Apenas letras e números',
            domainTaken: 'Este nome já está em uso',
            domainCheckError: 'Não foi possível verificar a disponibilidade',
            domainAvailable: 'Este nome está disponível!',
            checking: 'Verificando',
            chooseFile: 'Escolher arquivo',
            yourName: 'Nome ou título',
            yourNamePlaceholder: 'ex. João Silva ou Estúdio de Beleza',
            selectProfession: 'Selecione sua profissão',
            chooseProfession: '— Escolha uma profissão —',
            serviceName: 'Nome do serviço',
            serviceDesc: 'Descrição',
            min: 'min',
            addService: 'Adicionar serviço manualmente',
            presets: 'Modelos rápidos',
            workDays: 'Dias de trabalho',
            bookNow: 'Agendar agora',
            addPhotos: 'Adicionar fotos',
            phoneNumber: 'Número de telefone',
            impressumQuestion: 'Deseja adicionar informações legais?',
            impressumRecommended: 'Informações legais são recomendadas e em alguns países obrigatórias.',
            impressumEdit: 'Editar informações legais',
            impressumHint: 'Substitua os valores de exemplo pelas suas informações reais.',
            yes: 'Sim',
            no: 'Não, pular',
            cookieText: 'Este site usa cookies para garantir a melhor experiência.',
            cookieAccept: 'Aceitar',
            hasImage: 'Imagem enviada',
            empty: 'Não definido',
            photos: 'fotos',
            links: 'links',
            edit: 'Editar',
            hide: 'Ocultar',
            show: 'Mostrar',
            save: 'Salvar',
            cancel: 'Cancelar',
            galleryEditHint: 'A edição da galeria está disponível no editor completo.',
            elementManaged: 'Este elemento é gerenciado automaticamente.',
            appName: 'Timebrella',
            tagline: 'Proteção contra o caos',
        },
        footer: {
            impressum: 'Aviso legal',
            tos: 'Termos de serviço',
        },
    },
    cs: {
        language: 'Jazyk',
        menu: {
            website: 'Můj web',
            services: 'Služby',
            schedule: 'Rozvrh',
            appointments: 'Rezervace',
            profile: 'Profil',
            communication: 'Komunikace',
        },
        services: {
            title: 'Služby',
            empty: 'Zatím žádné služby.',
            minutes: 'min',
        },
        schedule: {
            title: 'Rozvrh',
            empty: 'Rozvrh zatím není nastaven.',
            dayOff: 'Volno',
            days: {
                monday: 'Pondělí',
                tuesday: 'Úterý',
                wednesday: 'Středa',
                thursday: 'Čtvrtek',
                friday: 'Pátek',
                saturday: 'Sobota',
                sunday: 'Neděle',
            },
        },
        appointments: {
            title: 'Rezervace',
            empty: 'Zatím žádné rezervace.',
            noService: 'Služba neuvedena',
            status: {
                pending: 'Čeká',
                confirmed: 'Potvrzeno',
                cancelled: 'Zrušeno',
            },
        },
        profile: {
            title: 'Profil',
            name: 'Jméno',
            email: 'Email',
            phone: 'Telefon',
            createdAt: 'Registrován',
            balance: 'Dostupný zůstatek',
        },
        registration: {
            successTitle: 'Zkontrolujte svůj email',
            successDesc: 'Poslali jsme vám potvrzovací email. Zkontrolujte svou schránku a klikněte na odkaz pro ověření účtu.',
            backToLogin: 'Přejít na přihlášení',
        },
        verification: {
            verifying: 'Ověřujeme váš email...',
            successTitle: 'Email ověřen!',
            successDesc: 'Váš účet byl úspěšně ověřen. Nyní se můžete přihlásit.',
            alreadyVerifiedTitle: 'Již ověřeno',
            alreadyVerifiedDesc: 'Váš účet již byl ověřen. Přihlaste se prosím.',
            errorTitle: 'Ověření se nezdařilo',
            errorDesc: 'Ověřovací odkaz je neplatný nebo vypršel.',
            brokenLink: 'Ověřovací odkaz je poškozený. Vyžádejte si nový.',
            resendLink: 'Znovu odeslat ověřovací odkaz',
            linkResent: 'Nový ověřovací odkaz byl odeslán na váš email.',
            goToLogin: 'Přejít na přihlášení',
        },
        onboarding: {
            step: 'Krok',
            next: 'Pokračovat',
            skip: 'Přeskočit tento krok',
            back: 'Zpět',
            professionTitle: 'Čím se zabýváte?',
            professionDesc: 'Řekněte nám o vaší profesi, abychom vám pomohli nastavit rychleji.',
            otherProfession: 'Jiné',
            step1Title: 'Vytvořit web',
            step2Title: 'Nahrát avatar',
            step3Title: 'Vaše jméno nebo název',
            step4Title: 'Nastavit služby',
            step5Title: 'Nastavit rozvrh',
            step55Title: 'Přidat fotky vaší práce',
            step6Title: 'Telefonní číslo',
            step7Title: 'E-mailová adresa',
            step8Title: 'Sociální sítě',
            step9Title: 'Právní informace',
            step1Desc: 'Vyberte unikátní název pro vaši rezervační stránku.',
            step2Desc: 'Nahrajte profilovou fotku.',
            step3Desc: 'Zadejte vaše jméno nebo název firmy.',
            step4Desc: 'Přidejte služby, které nabízíte.',
            step5Desc: 'Nastavte pracovní dobu.',
            step55Desc: 'Ukažte potenciálním klientům fotky vaší práce.',
            step6Desc: 'Přidejte telefonní číslo.',
            step7Desc: 'Přidejte email pro komunikaci.',
            step8Desc: 'Propojte vaše profily na sociálních sítích.',
            step9Desc: 'Právní informace o vás nebo vašem podnikání.',
            websiteName: 'Název webu',
            websiteNamePlaceholder: 'mujweb',
            domainMinLength: 'Minimálně 4 znaky',
            domainAlphaNum: 'Pouze písmena a čísla',
            domainTaken: 'Tento název je již obsazen',
            domainCheckError: 'Nepodařilo se ověřit dostupnost',
            domainAvailable: 'Tento název je dostupný!',
            checking: 'Ověřuji',
            chooseFile: 'Vybrat soubor',
            yourName: 'Jméno nebo název',
            yourNamePlaceholder: 'např. Jan Novák nebo Studio Krásy',
            selectProfession: 'Vyberte svou profesi',
            chooseProfession: '— Vyberte profesi —',
            serviceName: 'Název služby',
            serviceDesc: 'Popis',
            min: 'min',
            addService: 'Přidat službu ručně',
            presets: 'Rychlé šablony',
            workDays: 'Pracovní dny',
            bookNow: 'Rezervovat',
            addPhotos: 'Přidat fotky',
            phoneNumber: 'Telefonní číslo',
            impressumQuestion: 'Chcete přidat právní informace?',
            impressumRecommended: 'Právní informace jsou doporučené a v některých zemích povinné.',
            impressumEdit: 'Upravit právní informace',
            impressumHint: 'Nahraďte vzorové hodnoty vašimi skutečnými údaji.',
            yes: 'Ano',
            no: 'Ne, přeskočit',
            cookieText: 'Tento web používá cookies pro nejlepší zážitek.',
            cookieAccept: 'Přijmout',
            hasImage: 'Obrázek nahrán',
            empty: 'Nenastaveno',
            photos: 'fotek',
            links: 'odkazů',
            edit: 'Upravit',
            hide: 'Skrýt',
            show: 'Zobrazit',
            save: 'Uložit',
            cancel: 'Zrušit',
            galleryEditHint: 'Úprava galerie je dostupná v plném editoru.',
            elementManaged: 'Tento prvek je spravován automaticky.',
            appName: 'Timebrella',
            tagline: 'Ochrana před chaosem',
        },
        footer: {
            impressum: 'Impressum',
            tos: 'Podmínky použití',
        },
    },
}
